import { render, staticRenderFns } from "./ModalCrearCliente.vue?vue&type=template&id=3533182e"
import script from "./ModalCrearCliente.vue?vue&type=script&lang=js"
export * from "./ModalCrearCliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports